import AbandonedForm from './abandoned-form.svg';
import Account from './account.svg';
import AiAnimated from './ai-animated.svg';
import Ai from './ai.svg';
import AjaxError from './ajax-error.svg';
import Android from './android.svg';
import ApiError from './api-error.svg';
import ArrowCurve from './arrow-curve.svg';
import ArrowDiagonal from './arrow-diagonal.svg';
import ArrowDown from './arrow-down.svg';
import ArrowLeft from './arrow-left.svg';
import ArrowRight from './arrow-right.svg';
import ArrowUp from './arrow-up.svg';
import ArrowsCombine from './arrows-combine.svg';
import ArrowsHorizontal from './arrows-horizontal.svg';
import ArrowsVertical from './arrows-vertical.svg';
import AutoplayActive from './autoplay-active.svg';
import AutoplayInactive from './autoplay-inactive.svg';
import AxisBreak from './axis-break.svg';
import BarChartHorizontal from './bar-chart-horizontal.svg';
import BarChartVertical from './bar-chart-vertical.svg';
import BellDot from './bell-dot.svg';
import BellPlus from './bell-plus.svg';
import Bell from './bell.svg';
import Bolt from './bolt.svg';
import BookmarkArrow from './bookmark-arrow.svg';
import Browser from './browser.svg';
import BulkAdd from './bulk-add.svg';
import CalendarDot from './calendar-dot.svg';
import Calendar from './calendar.svg';
import CardStack from './card-stack.svg';
import CardText from './card-text.svg';
import CaretDown from './caret-down.svg';
import CaretUp from './caret-up.svg';
import ChangedFormElement from './changed-form-element.svg';
import CheckmarkFill from './checkmark-fill.svg';
import Checkmark from './checkmark.svg';
import ChevronDown from './chevron-down.svg';
import ChevronLeft from './chevron-left.svg';
import ChevronRight from './chevron-right.svg';
import ChevronUp from './chevron-up.svg';
import Clear from './clear.svg';
import ClickHand from './click-hand.svg';
import Click from './click.svg';
import ClickedWithError from './clicked-with-error.svg';
import Clip from './clip.svg';
import Clipboard from './clipboard.svg';
import Clock from './clock.svg';
import Close from './close.svg';
import Code from './code.svg';
import Collapse from './collapse.svg';
import Command from './command.svg';
import CommentNote from './comment-note.svg';
import CompareHalf from './compare-half.svg';
import CompareQuarter from './compare-quarter.svg';
import Console from './console.svg';
import Conversions from './conversions.svg';
import Copy from './copy.svg';
import CumulativeLayoutShift from './cumulative-layout-shift.svg';
import DashboardAdd from './dashboard-add.svg';
import Dashboard from './dashboard.svg';
import DataTable from './data-table.svg';
import DeadClick from './dead-click.svg';
import DefinedEvent from './defined-event.svg';
import Desktop from './desktop.svg';
import Detections from './detections.svg';
import DeviceServer from './device-server.svg';
import DeviceUnknown from './device-unknown.svg';
import Dinosaur from './dinosaur.svg';
import Disabled from './disabled.svg';
import DotEmpty from './dot-empty.svg';
import DotFilled from './dot-filled.svg';
import DoubleChevronLeft from './double-chevron-left.svg';
import DoubleChevronRight from './double-chevron-right.svg';
import Download from './download.svg';
import DragHorizontal from './drag-horizontal.svg';
import DragNarrow from './drag-narrow.svg';
import Drag from './drag.svg';
import Duplicate from './duplicate.svg';
import DurationRendered from './duration-rendered.svg';
import DurationVisible from './duration-visible.svg';
import EllipsisHorizontal from './ellipsis-horizontal.svg';
import EllipsisVertical from './ellipsis-vertical.svg';
import Email from './email.svg';
import Enable from './enable.svg';
import Envelope from './envelope.svg';
import EventList from './event-list.svg';
import Exclamation from './exclamation.svg';
import Exit from './exit.svg';
import Expand from './expand.svg';
import ExpandOut from './expand-out.svg';
import Export from './export.svg';
import EyeActive from './eye-active.svg';
import EyeInactive from './eye-inactive.svg';
import FilterAdd from './filter-add.svg';
import Filter from './filter.svg';
import FirstInputDelay from './first-input-delay.svg';
import Flag from './flag.svg';
import Folder from './folder.svg';
import ForceRestart from './force-restart.svg';
import FunnelTrends from './funnel-trends.svg';
import Funnels from './funnels.svg';
import Globe from './globe.svg';
import GraduationCap from './graduation-cap.svg';
import Grid from './grid.svg';
import Hamburger from './hamburger.svg';
import Heatmap from './heatmap.svg';
import HelpFill from './help-fill.svg';
import Home from './home.svg';
import ImageNotFound from './image-not-found.svg';
import Information from './information.svg';
import Insights from './insights.svg';
import Inspect from './inspect.svg';
import InteractionToNextPaint from './interaction-to-next-paint.svg';
import Ios from './ios.svg';
import Journeys from './journeys.svg';
import Keyboard from './keyboard.svg';
import Laptop from './laptop.svg';
import LargestContentfulPaint from './largest-contentful-paint.svg';
import Library from './library.svg';
import LifePreserver from './life-preserver.svg';
import LinkOut from './link-out.svg';
import Link from './link.svg';
import LocationPin from './location-pin.svg';
import Lock from './lock.svg';
import MetricInsight from './metric-insight.svg';
import Metrics from './metrics.svg';
import MinusCircle from './minus-circle.svg';
import Minus from './minus.svg';
import MobileSourceFile from './mobile-source-file.svg';
import Name from './name.svg';
import Note from './note.svg';
import ObjectChanges from './object-changes.svg';
import Pacifier from './pacifier.svg';
import PageLoad from './page-load.svg';
import PageRefresh from './page-refresh.svg';
import Page from './page.svg';
import Pause from './pause.svg';
import Pencil from './pencil.svg';
import People from './people.svg';
import Person from './person.svg';
import Phone from './phone.svg';
import PinchZoom from './pinch-zoom.svg';
import PlayOutline from './play-outline.svg';
import Play from './play.svg';
import PlusCircle from './plus-circle.svg';
import Plus from './plus.svg';
import Power from './power.svg';
import Pulse from './pulse.svg';
import Rage from './rage.svg';
import RaisedHand from './raised-hand.svg';
import ReArrange from './re-arrange.svg';
import Refresh from './refresh.svg';
import Replay from './replay.svg';
import Retention from './retention.svg';
import Rewind from './rewind.svg';
import ScrollDepth from './scroll-depth.svg';
import SearchEmptyState from './search-empty-state.svg';
import SearchPlus from './search-plus.svg';
import Search from './search.svg';
import Segments from './segments.svg';
import Send from './send.svg';
import Server from './server.svg';
import Sight from './sight.svg';
import SingleNumber from './single-number.svg';
import Sort from './sort.svg';
import StarFilled from './star-filled.svg';
import StarPerson from './star-person.svg';
import StarUnfilled from './star-unfilled.svg';
import State from './state.svg';
import Stop from './stop.svg';
import Stopwatch from './stopwatch.svg';
import String from './string.svg';
import SuspiciousActivity from './suspicious-activity.svg';
import TabChanged from './tab-changed.svg';
import TabClosed from './tab-closed.svg';
import Tab from './tab.svg';
import Tablet from './tablet.svg';
import TextHighlight from './text-highlight.svg';
import ThrashedCursor from './thrashed-cursor.svg';
import TimeToFirstByte from './time-to-first-byte.svg';
import TimeToInteractive from './time-to-interactive.svg';
import TotalBlockingTime from './total-blocking-time.svg';
import Trash from './trash.svg';
import UncaughtException from './uncaught-exception.svg';
import Undo from './undo.svg';
import Union from './union.svg';
import UnknownDevice from './unknown-device.svg';
import Upgrade from './upgrade.svg';
import UserAgent from './user-agent.svg';
import UserId from './user-id.svg';
import Visited from './visited.svg';
import WarningFill from './warning-fill.svg';
import Warning from './warning.svg';
import WebSourceFile from './web-source-file.svg';
import Wifi from './wifi.svg';

export default {
  'abandoned-form': AbandonedForm,
  account: Account,
  'ai-animated': AiAnimated,
  ai: Ai,
  'ajax-error': AjaxError,
  android: Android,
  'api-error': ApiError,
  'arrow-curve': ArrowCurve,
  'arrow-diagonal': ArrowDiagonal,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrows-combine': ArrowsCombine,
  'arrows-horizontal': ArrowsHorizontal,
  'arrows-vertical': ArrowsVertical,
  'autoplay-active': AutoplayActive,
  'autoplay-inactive': AutoplayInactive,
  'axis-break': AxisBreak,
  'bar-chart-horizontal': BarChartHorizontal,
  'bar-chart-vertical': BarChartVertical,
  'bell-dot': BellDot,
  'bell-plus': BellPlus,
  bell: Bell,
  bolt: Bolt,
  'bookmark-arrow': BookmarkArrow,
  browser: Browser,
  'bulk-add': BulkAdd,
  'calendar-dot': CalendarDot,
  calendar: Calendar,
  'card-stack': CardStack,
  'card-text': CardText,
  'caret-down': CaretDown,
  'caret-up': CaretUp,
  'changed-form-element': ChangedFormElement,
  'checkmark-fill': CheckmarkFill,
  checkmark: Checkmark,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  clear: Clear,
  'click-hand': ClickHand,
  click: Click,
  'clicked-with-error': ClickedWithError,
  clip: Clip,
  clipboard: Clipboard,
  clock: Clock,
  close: Close,
  code: Code,
  collapse: Collapse,
  command: Command,
  'comment-note': CommentNote,
  'compare-half': CompareHalf,
  'compare-quarter': CompareQuarter,
  console: Console,
  conversions: Conversions,
  copy: Copy,
  'cumulative-layout-shift': CumulativeLayoutShift,
  'dashboard-add': DashboardAdd,
  dashboard: Dashboard,
  'data-table': DataTable,
  'dead-click': DeadClick,
  'defined-event': DefinedEvent,
  desktop: Desktop,
  detections: Detections,
  'device-server': DeviceServer,
  'device-unknown': DeviceUnknown,
  dinosaur: Dinosaur,
  disabled: Disabled,
  'dot-empty': DotEmpty,
  'dot-filled': DotFilled,
  'double-chevron-left': DoubleChevronLeft,
  'double-chevron-right': DoubleChevronRight,
  download: Download,
  'drag-horizontal': DragHorizontal,
  'drag-narrow': DragNarrow,
  drag: Drag,
  duplicate: Duplicate,
  'duration-rendered': DurationRendered,
  'duration-visible': DurationVisible,
  'ellipsis-horizontal': EllipsisHorizontal,
  'ellipsis-vertical': EllipsisVertical,
  email: Email,
  enable: Enable,
  envelope: Envelope,
  'event-list': EventList,
  exclamation: Exclamation,
  exit: Exit,
  expand: Expand,
  'expand-out': ExpandOut,
  export: Export,
  'eye-active': EyeActive,
  'eye-inactive': EyeInactive,
  'filter-add': FilterAdd,
  filter: Filter,
  'first-input-delay': FirstInputDelay,
  flag: Flag,
  folder: Folder,
  'force-restart': ForceRestart,
  'funnel-trends': FunnelTrends,
  funnels: Funnels,
  globe: Globe,
  'graduation-cap': GraduationCap,
  grid: Grid,
  hamburger: Hamburger,
  heatmap: Heatmap,
  'help-fill': HelpFill,
  home: Home,
  'image-not-found': ImageNotFound,
  information: Information,
  insights: Insights,
  inspect: Inspect,
  'interaction-to-next-paint': InteractionToNextPaint,
  ios: Ios,
  journeys: Journeys,
  keyboard: Keyboard,
  laptop: Laptop,
  'largest-contentful-paint': LargestContentfulPaint,
  library: Library,
  'life-preserver': LifePreserver,
  'link-out': LinkOut,
  link: Link,
  'location-pin': LocationPin,
  lock: Lock,
  'metric-insight': MetricInsight,
  metrics: Metrics,
  'minus-circle': MinusCircle,
  minus: Minus,
  'mobile-source-file': MobileSourceFile,
  name: Name,
  note: Note,
  'object-changes': ObjectChanges,
  pacifier: Pacifier,
  'page-load': PageLoad,
  'page-refresh': PageRefresh,
  page: Page,
  pause: Pause,
  pencil: Pencil,
  people: People,
  person: Person,
  phone: Phone,
  'pinch-zoom': PinchZoom,
  'play-outline': PlayOutline,
  play: Play,
  'plus-circle': PlusCircle,
  plus: Plus,
  power: Power,
  pulse: Pulse,
  rage: Rage,
  'raised-hand': RaisedHand,
  're-arrange': ReArrange,
  refresh: Refresh,
  replay: Replay,
  retention: Retention,
  rewind: Rewind,
  'scroll-depth': ScrollDepth,
  'search-empty-state': SearchEmptyState,
  'search-plus': SearchPlus,
  search: Search,
  segments: Segments,
  send: Send,
  server: Server,
  sight: Sight,
  'single-number': SingleNumber,
  sort: Sort,
  'star-filled': StarFilled,
  'star-person': StarPerson,
  'star-unfilled': StarUnfilled,
  state: State,
  stop: Stop,
  stopwatch: Stopwatch,
  string: String,
  'suspicious-activity': SuspiciousActivity,
  'tab-changed': TabChanged,
  'tab-closed': TabClosed,
  tab: Tab,
  tablet: Tablet,
  'text-highlight': TextHighlight,
  'thrashed-cursor': ThrashedCursor,
  'time-to-first-byte': TimeToFirstByte,
  'time-to-interactive': TimeToInteractive,
  'total-blocking-time': TotalBlockingTime,
  trash: Trash,
  'uncaught-exception': UncaughtException,
  undo: Undo,
  union: Union,
  'unknown-device': UnknownDevice,
  upgrade: Upgrade,
  'user-agent': UserAgent,
  'user-id': UserId,
  visited: Visited,
  'warning-fill': WarningFill,
  warning: Warning,
  'web-source-file': WebSourceFile,
  wifi: Wifi,
};
